import * as React from 'react';
import TextField from '@material-ui/core/TextField';

interface INumberFieldProps{
    title: any,
    dataIndex: number,
    focusedId: string,
    idPrefix: string
    value: number | null,
    placeHolder: string
    error: string,
    editMode: boolean,
    onChange: (dataIndex: number, value: number, id: string) => void;
    removeFocusedId: () => void
}

export class NumberFieldCell extends React.Component<INumberFieldProps> {

    HandleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        event.preventDefault();
        this.props.onChange(
            this.props.dataIndex,
            parseFloat(event.target.value),
            event.target.id,
        );
    }


    render() {
        return (
            <td>
                <div className="genericDisplayCellTitle">
                    {this.props.title}:
                </div>
                <div className="genericDisplayCellContent">
                    {this.props.editMode == false && <div>
                        {this.props.value}
                    </div>}
                    {this.props.editMode && <TextField 
                        error={this.props.error !== "" && this.props.error != undefined}
                        id={this.props.idPrefix + this.props.dataIndex}
                        placeholder={this.props.placeHolder}
                        fullWidth
                        margin="normal"
                        helperText={this.props.error}
                        FormHelperTextProps={{ color: "red" }}
                        value={this.props.value}
                        type="number"
                        onChange={(e) => this.HandleChange(e)}
                        autoFocus={this.props.focusedId == (this.props.idPrefix + this.props.dataIndex)}                        
                        variant="outlined"
                        />}
                </div>
            </td>
        );
    }
}